/** Returns a usable positive integer for product quantity constraints. */
export function normalizeQuantityRule(value: number | null | undefined): number {
  return Number.isFinite(value) && Number(value) > 0
    ? Math.max(1, Math.trunc(Number(value)))
    : 1;
}

/** Returns the required quantity when a product first enters the cart. */
export function getInitialCartQuantity(
  lowestValue: number | null | undefined,
): number {
  return normalizeQuantityRule(lowestValue);
}

/** Increases an existing quantity by the product increment. */
export function getIncrementedCartQuantity(
  quantity: number,
  multipleValue: number | null | undefined,
): number {
  return quantity + normalizeQuantityRule(multipleValue);
}

/** Decreases by one increment, or returns null when the item must be removed. */
export function getDecrementedCartQuantity(
  quantity: number,
  lowestValue: number | null | undefined,
  multipleValue: number | null | undefined,
): number | null {
  const lowest = normalizeQuantityRule(lowestValue);
  const newQuantity = quantity - normalizeQuantityRule(multipleValue);
  return newQuantity < lowest ? null : newQuantity;
}

/** Adjusts an arbitrary quantity to the nearest valid step from the minimum. */
export function normalizeCartQuantity(
  quantity: number,
  lowestValue: number | null | undefined,
  multipleValue: number | null | undefined,
): number {
  const lowest = normalizeQuantityRule(lowestValue);
  const multiple = normalizeQuantityRule(multipleValue);

  if (!Number.isFinite(quantity) || quantity <= lowest) {
    return lowest;
  }

  const stepsFromLowest = Math.round((quantity - lowest) / multiple);
  return lowest + stepsFromLowest * multiple;
}